import { IconProps } from "./";
import Icon from "./assets/carousel_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Carousel(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
